import {createReducer, on} from '@ngrx/store';
import {DocumentsActions} from '../actions/documents.actions';
import {DeleteDialogState} from '../../interfaces/delete-dialog-state.interface';


export const initialDeleteDialogState: DeleteDialogState = {
  isOpen: false,
  document: null,
  isDeleting: false,
};

export const deleteDialogReducer = createReducer(
  initialDeleteDialogState,

  on(
    DocumentsActions.openDeleteConfirmDialog,
    (state, action) => ({
      ...state,
      isOpen: true,
      document: action.document,
      isDeleting: false,
    })
  ),

  on(
    DocumentsActions.closeDeleteConfirmDialog,
    (state) => ({
      ...state,
      isOpen: false,
      document: null,
    })
  ),

  on(
    DocumentsActions.deleteDocument,
    (state) => ({
      ...state,
      isDeleting: true,
    })
  ),

  on(
    DocumentsActions.deleteDocumentSuccess,
    (state) => ({
      ...state,
      isDeleting: false,
    })
  ),

  on(
    DocumentsActions.deleteDocumentFailure,
    (state) => ({
      ...state,
      isDeleting: false,
    })
  ),
);
